import * as types from "../actions/types";

const initialState = {
  loading: null,
  imageData: null,
  error: null,
  uploading: false,
  processing: false,
  canvas: {
    history: [],
    index: -1,
  },
};

const imageReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        uploading: false,
      };
    case types.UPLOAD_IMAGE_FAILURE:
      return {
        ...state,
        uploading: false,
        error: payload,
        loading: false,
      };
    case types.PROCESS_IMAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        imageData: payload,
        error: null,
        processing: false,
      };
    case types.PROCESS_IMAGE_FAILURE:
      return {
        ...state,
        loading: false,
        imageData: null,
        error: payload,
        processing: false,
      };

    case types.IMAGE_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.IMAGE_UPLOADING:
      return {
        ...state,
        uploading: true,
      };
    case types.IMAGE_PROCESSING:
      return {
        ...state,
        processing: true,
      };
    case types.STORE_CANVAS:
      return {
        ...state,
        canvas: payload,
      };

    case types.CLEAR_IMAGE_DATA:
      return {
        ...state,
        loading: null,
        imageData: null,
        error: null,
        uploading: false,
        processing: false,
        canvas: {
          history: [],
          index: -1,
        },
      };

    // clear current imagedata, and canvas history if new data is uploaded. because if the data is changed, image and drawing will be outdated otherwise
    case types.PROCESS_DATA_SUCCESS:
      return {
        ...state,
        imageData: null,
        canvas: {
          history: [],
          index: -1,
        },
      };

    default:
      return state;
  }
};

export default imageReducer;
